import { Preset } from '../../types/types';
import { createControllerFactory } from '../BookingCalendar/controller';
import dailyAgendaSettingsParams from './settingsParams';

export default createControllerFactory(
  Preset.DAILY_AGENDA_WIDGET,
  dailyAgendaSettingsParams,
);
